module.exports = __webpack_public_path__ + "static/analytics-workforce-management@2x-071d6ef7a5f9d8fb08dd20761fe4de4c.png";